import { render, staticRenderFns } from "./ChartDayCharge.vue?vue&type=template&id=5b2b880b"
import script from "./ChartDayCharge.vue?vue&type=script&lang=js"
export * from "./ChartDayCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports